import { Route } from "react-router";
import { Approved } from "@lending/pages/AutoLoan/Approved";
import { AutoDetails } from "@lending/pages/AutoLoan/AutoDetails";
import { ConfirmInfo } from "@lending/pages/AutoLoan/ConfirmInfo";
import { CreditPull } from "@lending/pages/AutoLoan/CreditPull";
import { RequestedAmount } from "@lending/pages/AutoLoan/RequestedAmount";
import { SelectedCar } from "@lending/pages/AutoLoan/SelectedCar";
import { AddIncome } from "@lending/pages/Common/AddIncome";
import { Address } from "@lending/pages/Common/Address";
import { ApplicationQuestions } from "@lending/pages/Common/ApplicationQuestions";
import { Disclosures } from "@lending/pages/Common/Disclosures";
import { EligibilitySelection } from "@lending/pages/Common/EligibilitySelection/index";
import { EmploymentDetails } from "@lending/pages/Common/EmploymentDetails";
import { LivingArrangement } from "@lending/pages/Common/LivingArrangement";
import { PersonalInfo } from "@lending/pages/Common/PersonalInfo";
import { PlaidPiiReview } from "@lending/pages/Common/PlaidPrefill/PersonalInfoReview";
import { PlaidPhoneNumber } from "@lending/pages/Common/PlaidPrefill/PlaidPhoneNumber";
import { Submitted } from "@lending/pages/Common/Submitted";
import { loadAutoLoanPrequalApp } from "@lending/utils/loadPrequalApp";
import { getCoApplicantRoutes } from "./coApplicantRoutes";
import { AutoLoanApplicationLayout } from "./layouts/AutoLoanApplicationLayout";
import { MainLayout } from "./MainLayout/MainLayout";
import { getMembershipShareRoutes } from "./membershipShareRoutes";
import { ProgressBarLayout } from "./ProgressBarLayout/ProgressBarLayout";

const autoLoanRoutes = (
  <>
    <Route path="eligibility" element={<EligibilitySelection />} />
    <Route path="questions" element={<ApplicationQuestions />} />
    <Route path=":applicationUuid" element={<AutoLoanApplicationLayout fallbackPath="/error" />}>
      <Route index element={null} />
      <Route path="eligibility" element={<EligibilitySelection />} />
      <Route path="questions" element={<ApplicationQuestions />} />
    </Route>
    <Route element={<MainLayout flowType="web" />}>
      <Route element={<ProgressBarLayout />}>
        <Route path="personal-info" element={<PersonalInfo />} />
        <Route path="phone" element={<PlaidPhoneNumber />} />
        <Route path="personal-info-review" element={<PlaidPiiReview />} />
        <Route
          path=":applicationUuid"
          element={<AutoLoanApplicationLayout fallbackPath="/product-selection" />}
        >
          <Route index element={null} />
          <Route path="phone" element={<PlaidPhoneNumber />} />
          <Route path="personal-info-review" element={<PlaidPiiReview />} />
          <Route path="personal-info" element={<PersonalInfo />} />
          <Route path="address" element={<Address />} />
          <Route path="living-arrangement" element={<LivingArrangement />} />
          <Route path="add-income" element={<AddIncome />} />
          <Route path="employment-details" element={<EmploymentDetails />} />
          {getCoApplicantRoutes({
            productType: "vehicle_loans",
            fallbackPath: "/auto-loan/:applicationUuid/selected-car",
          })}
          <Route path="selected-car" element={<SelectedCar />} />
          <Route path="requested-amount" element={<RequestedAmount />} />
          <Route path="auto-details" element={<AutoDetails />} />
          <Route path="disclosures" element={<Disclosures />} />
        </Route>
      </Route>
      <Route
        path=":applicationUuid"
        element={<AutoLoanApplicationLayout fallbackPath="/product-selection" />}
      >
        <Route index element={null} />
        <Route path="credit-pull" element={<CreditPull />} />
        <Route path="approved" element={<Approved />} />
        {getMembershipShareRoutes({ fallbackPath: "/auto-loan/:applicationUuid/submitted" })}
        <Route path="submitted" element={<Submitted />} />
      </Route>
    </Route>
  </>
);

const olbAutoLoanRoutes = (
  <>
    <Route path="confirm-info" loader={loadAutoLoanPrequalApp} />
    <Route
      path=":applicationUuid"
      element={<AutoLoanApplicationLayout fallbackPath="/olb-auto-loan/confirm-info" />}
    >
      <Route index element={null} />
      <Route element={<MainLayout flowType="olb" />}>
        <Route element={<ProgressBarLayout />}>
          <Route path="confirm-info" element={<ConfirmInfo />} />
          <Route path="living-arrangement" element={<LivingArrangement />} />
          <Route path="add-income" element={<AddIncome />} />
          <Route path="employment-details" element={<EmploymentDetails />} />
          {getCoApplicantRoutes({
            productType: "vehicle_loans",
            fallbackPath: "/olb-auto-loan/:applicationUuid/selected-car",
          })}
          <Route path="selected-car" element={<SelectedCar />} />
          <Route path="requested-amount" element={<RequestedAmount />} />
          <Route path="auto-details" element={<AutoDetails />} />
          <Route path="disclosures" element={<Disclosures />} />
        </Route>
        <Route path="credit-pull" element={<CreditPull />} />
        <Route path="approved" element={<Approved />} />
        <Route path="submitted" element={<Submitted />} />
      </Route>
    </Route>
  </>
);

export { autoLoanRoutes, olbAutoLoanRoutes };
